import ReactMarkdown from 'react-markdown';
import classnames from 'classnames';
import remarkGfm from 'remark-gfm';

export default function IntroMarkup({ className, text }) {
  if (text && text?.length > 0) {
    return (
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        className={classnames(className, 'body')}
      >
        {text}
      </ReactMarkdown>
    );
  }
  return null;
}
